/**
 * Skills data for the Competency Assessment module
 */
export const skillsData = {
  instructionalSkills: [
    { 
      name: "Content Development", 
      level: 95, 
      description: "Creating comprehensive learning materials for technical subjects",
      examples: [
        "Created comprehensive 'Indigorgeous' manual (74 pages)",
        "Developed Standard Operating Procedures for digital foil production",
        "Authored technical scripts for educational webinar series"
      ]
    },
    { 
      name: "Process Documentation", 
      level: 90, 
      description: "Documenting complex procedures in clear, accessible formats",
      examples: [
        "Created comprehensive equipment documentation for Duplo DC-746",
        "Developed troubleshooting guides with decision trees",
        "Documented multi-step technical processes with visual aids"
      ]
    },
    { 
      name: "Visual Communication", 
      level: 85, 
      description: "Creating diagrams and visual aids that clarify complex concepts",
      examples: [
        "Designed technical diagrams illustrating printing processes",
        "Created visual workflow charts for production procedures",
        "Developed interactive visual demonstrations for webinars"
      ]
    },
    { 
      name: "Learning Needs Analysis", 
      level: 80, 
      description: "Identifying knowledge gaps and planning educational interventions",
      examples: [
        "Assessed training needs for print production team members",
        "Identified documentation gaps in technical processes",
        "Developed targeted learning resources based on skill assessments"
      ]
    },
    { 
      name: "Training Program Design", 
      level: 85, 
      description: "Developing structured learning experiences with clear objectives",
      examples: [
        "Created quarterly webinar series with progressive knowledge building",
        "Designed hands-on equipment training programs",
        "Developed self-paced learning modules for technical skills"
      ]
    }
  ],

  technicalSkills: [
    { 
      name: "Adobe Creative Suite", 
      level: 90, 
      description: "Expert in Photoshop, Illustrator, InDesign, Acrobat",
      examples: [
        "Created technical documentation with InDesign",
        "Developed process diagrams with Illustrator",
        "Prepared visual aids with Photoshop"
      ]
    },
    { 
      name: "Microsoft Office", 
      level: 85, 
      description: "Advanced Excel, Word, PowerPoint with VBA automation",
      examples: [
        "Developed calculation tools with Excel VBA",
        "Created training presentations with PowerPoint",
        "Authored technical documents with Word"
      ]
    },
    { 
      name: "HTML/CSS", 
      level: 70, 
      description: "Creating structured web content and responsive designs",
      examples: [
        "Developed interactive web-based training modules",
        "Created responsive documentation layouts",
        "Built web applications for educational purposes"
      ]
    },
    { 
      name: "Python", 
      level: 75, 
      description: "Automation scripting and data processing",
      examples: [
        "Created workflow automation scripts for production processes",
        "Developed web scraping tools for data collection",
        "Built data processing pipelines for analytics"
      ]
    },
    { 
      name: "React/JavaScript", 
      level: 70, 
      description: "Building interactive web applications",
      examples: [
        "Developed interactive learning tools for technical concepts",
        "Created educational web applications for process visualization",
        "Built interactive resume demonstrating instructional design principles"
      ]
    }
  ],

  professionalSkills: [
    { 
      name: "Technical Communication", 
      level: 95, 
      description: "Translating complex concepts for varied audiences",
      examples: [
        "Explained complex printing processes to non-technical clients",
        "Created accessible documentation for technical procedures",
        "Developed presentations for diverse audience technical levels"
      ]
    },
    { 
      name: "Project Management", 
      level: 85, 
      description: "Coordinating multi-stage projects with multiple stakeholders",
      examples: [
        "Managed development of comprehensive technical documentation",
        "Coordinated educational content creation across teams",
        "Led webinar series development from concept to execution"
      ]
    },
    { 
      name: "Stakeholder Collaboration", 
      level: 80, 
      description: "Working with subject matter experts to develop content",
      examples: [
        "Collaborated with production teams to document processes",
        "Worked with technical experts to develop training materials",
        "Coordinated with designers and writers for educational content"
      ]
    },
    { 
      name: "Process Analysis", 
      level: 90, 
      description: "Breaking down complex systems for documentation and teaching",
      examples: [
        "Analyzed production workflows for documentation and optimization",
        "Identified key learning points in complex technical procedures",
        "Developed process maps for training and documentation"
      ]
    },
    { 
      name: "Problem Solving", 
      level: 85, 
      description: "Developing creative solutions to technical and educational challenges",
      examples: [
        "Created innovative approaches to explain complex concepts",
        "Developed workarounds for technical limitations in documentation",
        "Solved production bottlenecks through improved training"
      ]
    }
  ]
};
